import React, { useEffect, useState } from "react";
import {
  CircularProgress,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormLabel,
  MenuItem,
  Select,
} from "@mui/material";
import GridItem from "../../../components/Grid/GridItem";
import TranslationWrapper from "../../../components/TranslationWrapper/TranslationWrapper";
import GridContainer from "../../../components/Grid/GridContainer";
import SaveButton from "../../../components/CustomInput/SaveButton";
import Subscription from "../../../licensing/Models/Subscription";
import { useDialog } from "../../../licensing/utils/DialogProvider";
import ControlledInput from "../../../components/CustomInput/ControlledInput";
import SubscriptionLine, { Period, Type } from "../../../licensing/Models/SubscriptionLine";
import * as actions from "../../../store/actions";
import { connect } from "react-redux";
import { toast } from "react-toastify";

function NewSubscriptionLine(props) {
  const [newSubscriptionLine, setNewSubscriptionLine] = useState(null);

  const [saving, setSaving] = useState(false);
  const [hasError, setHasError] = useState(false);
  const [subscription, setSubscription] = useState(null);
  const [, closeDialog] = useDialog();

  useEffect(() => {
    if (props.subscriptionId) {
      Subscription.get(props.subscriptionId).then(({ model }) => {
        setSubscription(model);
        setNewSubscriptionLine(
          new SubscriptionLine(
            0,
            props.subscriptionId,
            "",
            null,
            Type.QR,
            1,
            null,
            new Date(),
            null,
            new Date(),
            "ACTIVE",
            "ACTIVE",
            model.period,
            model.invoice_period,
            0
          )
        );
      });
    }
  }, []);
  return (
    <>
      <DialogTitle>New subscription line</DialogTitle>
      <DialogContent style={{ minHeight: 400 }}>
        {newSubscriptionLine == null ? <CircularProgress /> : null}
        {newSubscriptionLine != null ? (
          <GridContainer>
            <GridItem sm={4} xs={12}>
              <FormLabel>
                <TranslationWrapper tKey={"Type"} />
              </FormLabel>
            </GridItem>
            <GridItem sm={8} xs={12}>
              <Select
                onChange={(e) => {
                  newSubscriptionLine.type = e.target.value;
                  if (newSubscriptionLine.type !== Type.CUSTOM) {
                    newSubscriptionLine.unit_price = null;
                  }
                  setNewSubscriptionLine(Object.assign(Object.create(newSubscriptionLine), newSubscriptionLine));
                }}
                style={{ width: "100%" }}
                value={newSubscriptionLine.type}
              >
                {Object.keys(Type).map((type) => {
                  return <MenuItem value={type}>{type}</MenuItem>;
                })}
              </Select>
            </GridItem>
            <GridItem sm={4} xs={12}>
              <FormLabel>
                <TranslationWrapper tKey={"Quantity"} />
              </FormLabel>
            </GridItem>
            <GridItem sm={8} xs={12}>
              <ControlledInput
                name={"count"}
                onHandleValue={(value) => {
                  newSubscriptionLine.count = value;
                  setNewSubscriptionLine(Object.assign(Object.create(newSubscriptionLine), newSubscriptionLine));
                }}
                style={{ width: "100%" }}
                type={"number"}
                value={newSubscriptionLine.count}
              />
            </GridItem>
            <GridItem sm={4} xs={12}>
              <FormLabel>
                <TranslationWrapper tKey={"Start date"} />
              </FormLabel>
            </GridItem>
            <GridItem sm={8} xs={12}>
              <ControlledInput
                onHandleValue={(value) => {
                  newSubscriptionLine.start_date = value;
                  newSubscriptionLine.next_date = value;
                  setNewSubscriptionLine(Object.assign(Object.create(newSubscriptionLine), newSubscriptionLine));
                }}
                style={{ width: "100%" }}
                type={"date"}
                value={newSubscriptionLine.start_date}
              />
            </GridItem>
            <GridItem sm={4} xs={12}>
              <FormLabel>
                <TranslationWrapper tKey={"License Period"} />
              </FormLabel>
            </GridItem>
            <GridItem sm={8} xs={12}>
              <Select
                onChange={(e) => {
                  newSubscriptionLine.period = e.target.value;
                  if (e.target.value === Period.MONTH) {
                    newSubscriptionLine.invoice_period = { every: { months: 1 } };
                  }
                  setNewSubscriptionLine(Object.assign(Object.create(newSubscriptionLine), newSubscriptionLine));
                }}
                style={{ width: "100%" }}
                value={newSubscriptionLine.period}
              >
                {Object.keys(Period).map((period) => {
                  return <MenuItem value={period}>{period}</MenuItem>;
                })}
              </Select>
            </GridItem>
            <GridItem sm={4} xs={12}>
              <FormLabel>
                <TranslationWrapper tKey={"Invoice Period"} />
              </FormLabel>
            </GridItem>
            <GridItem sm={8} xs={12}>
              <Select
                onChange={(e) => {
                  newSubscriptionLine.invoice_period = {
                    every: { months: e.target.value },
                  };
                  setNewSubscriptionLine(Object.assign(Object.create(newSubscriptionLine), newSubscriptionLine));
                }}
                style={{ width: "100%" }}
                value={newSubscriptionLine.invoice_period.every.months}
              >
                <MenuItem value={1}>
                  <TranslationWrapper tKey={"Every month"} />
                </MenuItem>
                <MenuItem disabled={newSubscriptionLine.period === Period.MONTH} value={3}>
                  <TranslationWrapper tKey={"Every 3 months"} />
                </MenuItem>
                <MenuItem disabled={newSubscriptionLine.period === Period.MONTH} value={6}>
                  <TranslationWrapper tKey={"Every half a year"} />
                </MenuItem>
                <MenuItem disabled={newSubscriptionLine.period === Period.MONTH} value={12}>
                  <TranslationWrapper tKey={"Yearly"} />
                </MenuItem>
              </Select>
            </GridItem>
            {newSubscriptionLine.type === Type.CUSTOM ? (
              <>
                <GridItem sm={4} xs={12}>
                  <FormLabel>
                    <TranslationWrapper tKey={"Unit price"} />
                  </FormLabel>
                </GridItem>
                <GridItem sm={8} xs={12}>
                  <ControlledInput
                    onHandleValue={(value) => {
                      newSubscriptionLine.unit_price = value;
                      setNewSubscriptionLine(Object.assign(Object.create(newSubscriptionLine), newSubscriptionLine));
                    }}
                    style={{ width: "100%" }}
                    type={"currency"}
                    value={newSubscriptionLine.unit_price}
                  />
                </GridItem>
              </>
            ) : null}
            <GridItem sm={4} xs={12}>
              <FormLabel>
                <TranslationWrapper tKey={"Custom Description"} />
              </FormLabel>
            </GridItem>
            <GridItem sm={8} xs={12}>
              <ControlledInput
                onHandleValue={(value) => {
                  newSubscriptionLine.description = value;
                  setNewSubscriptionLine(Object.assign(Object.create(newSubscriptionLine), newSubscriptionLine));
                }}
                style={{ width: "100%" }}
                type={"text"}
                value={newSubscriptionLine.description}
              />
            </GridItem>
          </GridContainer>
        ) : null}
      </DialogContent>
      <DialogActions style={{ justifyContent: "center" }}>
        <SaveButton
          buttonText={<TranslationWrapper tDefault={"Opslaan"} tKey={"global.jamezzForm.savebutton.text"} />}
          disabled={subscription == null}
          hasError={hasError}
          onClick={() => {
            setSaving(true);

            newSubscriptionLine
              .apiCreate()
              .then(() => {
                props.onSaved();
                closeDialog();
              })
              .catch(() => {
                setSaving(false);
                toast.error("Error");
              });
          }}
          saving={saving}
          type={"submit"}
        />
      </DialogActions>
    </>
  );
}

const mapDispatchToProps = (dispatch) => {
  return {
    showMessage: (message) => dispatch({ type: actions.SHOW_MESSAGE, message: message }),
  };
};

export default connect(null, mapDispatchToProps)(NewSubscriptionLine);
